import { useId, type ReactElement } from 'react';

import styles from './ChoiceChips.module.css';

export interface ChipOption<T extends string> {
    value: T;
    label: string;
}

export function ChoiceChips<T extends string>({
    label,
    value,
    options,
    onChange,
}: {
    label: string;
    value: T | null;
    options: readonly ChipOption<T>[];
    onChange: (value: T) => void;
}): ReactElement {
    const labelId = useId();
    return (
        <div>
            <p className={styles.legend} id={labelId}>
                {label}
            </p>
            <div className={styles.group} role="radiogroup" aria-labelledby={labelId}>
                {options.map((option) => {
                    const selected = option.value === value;
                    return (
                        <button
                            key={option.value}
                            type="button"
                            role="radio"
                            className={selected ? `${styles.chip} ${styles.selected}` : styles.chip}
                            aria-checked={selected}
                            onClick={() => {
                                onChange(option.value);
                            }}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
